import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface BodyProps extends ComponentPropsWithoutRef<"div"> {
  /**
   * When true, the Body fills its parent's height and lays out as a flex
   * column so a descendant can own its own scroll region through flexbox
   * (e.g. the chat space), instead of relying on a JS-measured static height.
   */
  fullHeight?: boolean;
}

export const Body = ({
  className,
  children,
  fullHeight = false,
  ...rest
}: BodyProps) => (
  <div
    className={classNames(
      anchorClassNames("main"),
      fullHeight && "flex min-h-0 flex-1 flex-col",
    )}
    {...rest}
  >
    <div
      className={classNames(
        anchorClassNames("main__wrapper"),
        fullHeight && "flex min-h-0 flex-1 flex-col",
        className,
      )}
    >
      {children}
    </div>
  </div>
);
